import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { fetchCatalogTable, setCatalogPage } from 'store/catalogs/actions';
import Line from './Line';

export default compose(
  connect(
    (state) => ({
      params: state.catalogs.catalogParams,
      listLines: state.catalogs.lineTable.list,
      loader: state.commons.loader,
      confirmationMessage: false,
    }),
    {
      fetchCatalogTable,
      setCatalogPage,
    }
  )
)(Line);
